import Cookies from "js-cookie";
import moment from "moment";

export const getAccessToken = () => {
  return Cookies.get("accessToken");
};
export const setAccessToken = (data) => {
  return Cookies.set("accessToken", data);
};
export const clearAccessToken = () => {
  return Cookies.remove("accessToken", { path: "/" });
};

export const formatDate = (input) => {
  return moment(input).format("DD MMMM YYYY");
};

export const formatDateTime = (input) => {
  return moment(input).format("DD MMMM YYYY, hh:mm A");
};
export const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const paddedSecs = secs.toString().padStart(2, "0");

  return `${mins}:${paddedSecs} min`;
};

export const renderTableCell = (value, defaultValue = "-") => {
  if (Array.isArray(value)) {
    return value.length === 0 ? defaultValue : value.join(", ");
  }
  if (typeof value === "number") {
    return String(value);
  }
  return value?.trim() === "" || value == null ? defaultValue : value;
};
